module.exports = __webpack_public_path__ + "img/logobranca.32fc830f.png";